import React from "react";
import styled from "styled-components";
import Application from "../apiResources/Application";
import Candidate from "../apiResources/Candidate";
import { formatCurrency } from "../helpers/formatters";
import ApplicationStatusTag from "./ApplicationStatusTag";
import Button from "./library/Button";
import { Card, CardTitle } from "./library/Card";
import TextLink from "./library/TextLink";

const ApplicantCard = (props: ApplicantCardProps) => {
  const { candidate, application, newApplicationPath } = props;

  const payType = candidate.jobType === "permanent" ? "salary" : "day rate";

  const backTo = `?back_to=${encodeURIComponent(window.location.href)}`;

  const gotoNewApplication = () => {
    window.location.href = newApplicationPath;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>
          {application ? (
            candidate.fullName
          ) : (
            <CardTitleLink href={candidate.viewCandidateLink + backTo}>
              {candidate.fullName}
            </CardTitleLink>
          )}
        </CardTitle>
        {application ? (
          <ApplicationStatusTag status={application.status} />
        ) : (
          <TextLink href={candidate.viewCvLink + backTo}>View CV</TextLink>
        )}
      </CardHeader>
      <Row>
        <div>
          <Title>Min {payType}</Title>
          <div>{formatCurrency(candidate.desiredSalary)}</div>
        </div>
        <div>
          <Title>Notice Period</Title>
          <div>{candidate.noticePeriod || '-'}</div>
        </div>
        <ButtonGroup>
          {application ? (
            <TextLink href={application.recruiterViewLink}>
              View application
            </TextLink>
          ) : (
            <Button size="sm" primary onClick={gotoNewApplication}>
              Submit to role
            </Button>
          )}
        </ButtonGroup>
      </Row>
    </Card>
  );
};

type ApplicantCardProps = {
  candidate: Candidate;
  application: Application;
  newApplicationPath: string;
};

const Row = styled.div`
  margin-top: 0.5rem;
  display: grid;
  flex-direction: row;
  grid-template-columns: 150px 150px 1fr;
`;

const CardHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
`;

const ButtonGroup = styled.div`
  text-align: right;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;

const CardTitleLink = styled.a`
  &&& {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.text};
    transition: color: 180ms;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export default ApplicantCard;
